module.exports = __webpack_public_path__ + "static/save-money-0c09dd6c79134d9a3449fcd13b835a90.gif";